import { atom } from 'jotai';
import { NizzaAccount } from '../core';

export const accountAtom: ReturnType<typeof atom<NizzaAccount | null>> =
  atom<NizzaAccount | null>(null);
accountAtom.debugLabel = 'accountAtom';
